<template>
  <ion-page>
    <template v-if="order.status == 'solicitado'">
      <PreProduction />
    </template>
    <template v-else-if="order.status == 'producción' && order.rotomolde == 0">
      <Production />
    </template>
    <template v-else>
      <PostProduction />
    </template>
  </ion-page>
</template>

<script>
import { IonPage } from "@ionic/vue";
import useOrder from "@/use/useOrder";
import PreProduction from "@/views/system/rotomolde/detail/preProduction.vue";
import Production from "@/views/system/rotomolde/detail/production.vue";
import PostProduction from "@/views/system/rotomolde/detail/postProduction.vue";
import { useRoute } from "vue-router";

export default {
  name: "Order detail",
  components: {
    IonPage,
    PreProduction,
    Production,
    PostProduction,
  },
  setup() {
    const { params } = useRoute();
    const { order, getOrder } = useOrder();
    if (!order.value) {
      getOrder(params.id, 'rotomolde');
    } else if (Object.keys(order.value).length === 0) {
      getOrder(params.id, 'rotomolde');
    }
    return {
      order,
    };
  },
};
</script>

<style></style>
